import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { LettersDashboard } from '../components/letters/LettersDashboard';
import { LetterTable } from '../components/letters/LetterTable';
import { LetterTemplatesTab } from '../components/letters/LetterTemplatesTab';
import { ClearanceTrackerTab } from '../components/letters/ClearanceTrackerTab';
import { LetterSettingsTab } from '../components/letters/LetterSettingsTab';
import { lettersAPI } from '../lib/lettersAPI';

const TABS = [['dashboard', 'Dashboard'], ['templates', 'Letter Templates'], ['drafts', 'Drafts'], ['pending', 'Pending Approval'],
  ['issued', 'Sent / Issued'], ['clearance', 'Ethical Clearance Tracker'], ['settings', 'Letter Settings']];

export default function AccountantLetters() {
  const [sp, setSp] = useSearchParams();
  const navigate = useNavigate();
  const [meta, setMeta] = useState(null);
  const tab = sp.get('tab') || 'dashboard';
  useEffect(() => { lettersAPI.meta().then(setMeta).catch((e) => { if (e?.response?.status === 403) navigate('/my-letters', { replace: true }); }); }, [navigate]);
  return (
    <div className="space-y-6 p-6" data-testid="letters-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>Accountants Letters</h1>
          <p className="mt-1 text-sm text-muted-foreground">Factual letters on your letterhead – approved templates, sign-off and an immutable record.</p>
        </div>
        {meta?.me?.can_create && <Button onClick={() => navigate('/letters/new')} data-testid="letters-create-btn"><Plus className="mr-2 h-4 w-4" />Create Letter</Button>}
      </div>
      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })}>
        <TabsList className="flex h-auto flex-wrap">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`letters-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="dashboard"><LettersDashboard /></TabsContent>
        <TabsContent value="templates"><LetterTemplatesTab meta={meta} /></TabsContent>
        <TabsContent value="drafts"><LetterTable status="draft" /></TabsContent>
        <TabsContent value="pending"><LetterTable status="pending_approval,approved" /></TabsContent>
        <TabsContent value="issued"><LetterTable status="issued,sent" /></TabsContent>
        <TabsContent value="clearance"><ClearanceTrackerTab /></TabsContent>
        <TabsContent value="settings"><LetterSettingsTab meta={meta} /></TabsContent>
      </Tabs>
    </div>
  );
}
